export enum FormatType {
  String = "STRING",
  Markdown = "MARKDOWN",
  Html = "HTML",
  Othe = "OTHER",
}